"use client";
import PropTypes from "prop-types";
import { useCallback, useRef } from "react";

/**
 * Returns Video Player
 * @returns
 */
const VideoPlayer = ({
  videoUrl,
  width = "100%",
  height = "100%",
  title,
  classes,
  isControls = false,
  isAutoPlay = false,
  isMuted = false,
  isLoop = false,
  isPlaysInline = false,
  isAllowDownload = false,
  onPlaying = null,
  customRef = null,
  testId = "",
  preload = "metadata",
  poster = "",
  id = "",
  onMouseOver = () => {},
  onMouseLeave = () => {},
  onEnded = () => {},
  onError = () => {},
  ...restParams
}) => {
  const videoRef = useRef(null);

  /**
   * Play Pause handler.
   * @param {bool} isPlaying
   */
  const onPlayPauseHandler = (e, isPlaying) => {
    onPlaying?.(e, isPlaying);
  };

  /**
   *
   * @param {*} ref
   */
  const getRef = (ref) => {
    setTimeout(() => {
      videoRef.current = ref;
      if (customRef) {
        customRef.current = ref;
      }
    }, 100);
  };
  const renderVideoPlayer = useCallback(() => {
    return (
      <video
        ref={(e) => getRef(e)}
        src={`${videoUrl}#t=0.01`}
        data-src={`${videoUrl}#t=0.01`}
        width={width}
        height={height}
        title={title}
        className={classes}
        controlsList={isAllowDownload ? "" : "nodownload"}
        preload={preload}
        controls={isControls}
        autoPlay={isAutoPlay}
        muted={isMuted}
        loop={isLoop}
        data-testid={testId}
        playsInline={isPlaysInline}
        webkit-playsinline={isPlaysInline ? "true" : undefined}
        x5-playsinline={isPlaysInline ? "true" : undefined}
        x-webkit-airplay="allow"
        onPause={(e) => onPlayPauseHandler(e, false)}
        onPlay={(e) => onPlayPauseHandler(e, true)}
        poster={poster}
        id={id}
        onMouseOver={onMouseOver}
        onMouseLeave={onMouseLeave}
        onEnded={onEnded}
        onError={onError}
        {...restParams}
      />
    );
  }, [isMuted, isAutoPlay]);

  return renderVideoPlayer();
};

VideoPlayer.propTypes = {
  videoUrl: PropTypes.string.isRequired,
  width: PropTypes.string,
  height: PropTypes.string,
  title: PropTypes.string,
  classes: PropTypes.string,
  isControls: PropTypes.bool,
  isAutoPlay: PropTypes.bool,
  isMuted: PropTypes.bool,
  isLoop: PropTypes.bool,
  isPlaysInline: PropTypes.bool,
  isAllowDownload: PropTypes.bool,
  onPlaying: PropTypes.func,
  customRef: PropTypes.object,
  testId: PropTypes.string,
  preload: PropTypes.string,
  poster: PropTypes.string,
  id: PropTypes.string,
  onMouseOver: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onEnded: PropTypes.func,
  onError: PropTypes.func,
};

export default VideoPlayer;
